import EditableImage from "../components/EditableImage";

const HOME_IMAGE_FALLBACK = "https://customer-assets.emergentagent.com/job_swen-store-dev/artifacts/t46tlbx3_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2009_04_21%20PM.png";

const Home = () => (
  <div
    data-testid="home-page"
    className="fixed inset-0 z-0 overflow-hidden"
  >
    <EditableImage
      imageKey="home_hero"
      fallback={HOME_IMAGE_FALLBACK}
      alt="Swenkville SV25"
      className="w-full h-full object-cover block fade-in"
    />
  </div>
);

export default Home;
